import React from "react";
import { StyledMainContentView } from "./index.styled";
import AppSuspense from "_lib/AppSuspense";
import AppErrorBoundary from "_lib/AppErrorBoundary";
import PropTypes from "prop-types";

const AppContentView = (props) => {
  const { routes } = props;
  return (
    <StyledMainContentView>
      <AppSuspense>
        <AppErrorBoundary>{routes}</AppErrorBoundary>
      </AppSuspense>
    </StyledMainContentView>
  );
};
AppContentView.propTypes = {
  routes: PropTypes.object.isRequired,
};
export default AppContentView;
